import type { PurposeConsents, VendorConsents, VendorsList } from "../analytics/cmp/types";
import { AppEvent } from ".";

type ConsentAcceptedDetail = {
  type: "consentAccepted";
  vendorsList: VendorsList;
  vendorConsents: VendorConsents;
  purposeConsents: PurposeConsents;
};

export class ConsentAcceptedEvent extends AppEvent<ConsentAcceptedDetail> {
  constructor({ vendorsList, vendorConsents, purposeConsents }: Omit<ConsentAcceptedDetail, "type">) {
    super({ type: "consentAccepted", vendorsList, vendorConsents, purposeConsents });
  }
}
